<div class="home">
  <div class="home__layout">

  <app-category-nav [selectedSlug]="selectedCategory()" />
  <!-- ── Main content: product grid ────────────────────────────── -->
  <main class="main" id="catalog">

    <!-- Breadcrumb / active filter -->
    <div class="main__toolbar">
      <span class="main__breadcrumb">
        Товари
        @if (selectedCategoryName() !== null) {
          <span class="main__breadcrumb-sep">›</span>
          <span class="main__breadcrumb-cat">{{ selectedCategoryName() }}</span>
        }
      </span>

      <span class="main__toolbar-side">
        @if (rangeLabel()) {
          <span class="main__count">{{ rangeLabel() }}</span>
        }
        @if (selectedCategory() !== null) {
          <button class="main__clear-btn" (click)="selectCategory(null)">
            × Скинути фільтр
          </button>
        }
      </span>
    </div>

    <!-- Loading skeleton grid -->
    @if (loadingProducts()) {
      <div class="product-grid">
        @for (s of skeletonItems; track $index) {
          <div class="product-card product-card--skeleton">
            <div class="product-card__img-skeleton"></div>
            <div class="product-card__body">
              <div class="product-card__line product-card__line--lg"></div>
              <div class="product-card__line product-card__line--sm"></div>
              <div class="product-card__line product-card__line--md"></div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Error state -->
    @if (productsError()) {
      <div class="main__error">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="40" height="40">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p>Не вдалося завантажити товари</p>
        <button class="main__retry-btn" (click)="reloadProducts()">Спробувати знову</button>
      </div>
    }

    <!-- Product cards -->
    @if (!loadingProducts() && !productsError()) {
      <div class="product-grid">
        @for (product of products(); track product.id) {
          <div class="product-card" [class.product-card--in-cart]="cartQty(product) > 0">
            @if (cartQty(product) > 0) {
              <span class="product-card__cart-flag">У кошику · {{ cartQty(product) }}</span>
            }
            <a class="product-card__img-wrap" [routerLink]="['/product', product.sku]">
              @if (product.imageUrl) {
                <img
                  class="product-card__img"
                  [src]="product.imageUrl"
                  [alt]="product.name"
                  loading="lazy"
                />
              } @else {
                <div class="product-card__img-placeholder">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="40" height="40" opacity="0.3">
                    <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21 15 16 10 5 21"/>
                  </svg>
                </div>
              }
            </a>
            <div class="product-card__body">
              <p class="product-card__sku">{{ product.sku }}</p>
              <h3 class="product-card__name">
                <a class="product-card__name-link" [routerLink]="['/product', product.sku]">{{ product.name }}</a>
              </h3>
              @if (product.weightLabel) {
                <p class="product-card__weight-text">{{ product.weightLabel }}</p>
              }
              <div class="product-card__footer">
                @if (product.price != null) {
                  <span class="product-card__price">{{ product.price | number:'1.2-2' }} грн</span>
                } @else {
                  <span class="product-card__price product-card__price--na">Ціна за запитом</span>
                }
                @if (cartQty(product) > 0) {
                  <div class="product-card__qty" (click)="$event.stopPropagation()">
                    <button
                      class="product-card__qty-btn"
                      type="button"
                      (click)="changeCartQty(product, -1)"
                    >−</button>
                    <span class="product-card__qty-val">{{ cartQty(product) }}</span>
                    <button
                      class="product-card__qty-btn"
                      type="button"
                      (click)="changeCartQty(product, 1)"
                    >+</button>
                  </div>
                } @else {
                  <button
                    class="product-card__btn"
                    [class.product-card__btn--added]="isAdded(product.id)"
                    type="button"
                    (click)="addToCart(product); $event.stopPropagation()"
                  >{{ isAdded(product.id) ? 'Додано!' : 'До кошика' }}</button>
                }
              </div>
            </div>
          </div>
        }

        @if (products().length === 0) {
          <div class="main__empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="52" height="52" opacity="0.25">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            <p>Товари ще не додані</p>
            <span>Каталог незабаром поповниться</span>
          </div>
        }
      </div>
    }

    @if (!productsError() && pageCount() > 1) {
      <nav class="pager" aria-label="Сторінки каталогу">
        @if (page() === 1) {
          <span class="pager__btn pager__btn--disabled">Назад</span>
        } @else {
          <a class="pager__btn" routerLink="." [queryParams]="pageQuery(page() - 1)" queryParamsHandling="merge">Назад</a>
        }

        @for (item of pageItems(); track $index) {
          @if (item === 'gap') {
            <span class="pager__gap" aria-hidden="true">…</span>
          } @else if (item === page()) {
            <span class="pager__btn pager__btn--current" aria-current="page">{{ item }}</span>
          } @else {
            <a class="pager__btn" routerLink="." [queryParams]="pageQuery(item)" queryParamsHandling="merge">{{ item }}</a>
          }
        }

        @if (page() === pageCount()) {
          <span class="pager__btn pager__btn--disabled">Далі</span>
        } @else {
          <a class="pager__btn" routerLink="." [queryParams]="pageQuery(page() + 1)" queryParamsHandling="merge">Далі</a>
        }
      </nav>
    }

  </main>
  </div>
</div>
